var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.464C2.96533 16.7147 5.39733 14.784 7.296 12.672C9.19467 10.56 10.144 8.52267 10.144 6.56C10.144 5.51467 9.81333 4.68267 9.152 4.064C8.512 3.424 7.60533 3.104 6.432 3.104C5.32267 3.104 4.384 3.31733 3.616 3.744C2.86933 4.14933 2.13333 4.68267 1.408 5.344L0.192 3.584C0.618667 3.05067 1.22667 2.50667 2.016 1.952C2.82667 1.39733 3.76533 0.938667 4.832 0.576C5.89867 0.192 6.976 0 8.064 0C9.62133 0 10.9227 0.266667 11.968 0.800001C13.0347 1.33333 13.824 2.03733 14.336 2.912C14.848 3.78667 15.104 4.75734 15.104 5.824C15.104 7.872 14.1227 9.93067 12.16 12C10.1973 14.0693 7.70133 15.968 4.672 17.696L13.952 16.832L15.168 14.144L17.184 14.56L16.256 20.192H0.672L0 18.464Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.dcf2e82de7e41be199e748a14e49bb10.svg";
export { ForwardRef as ReactComponent };